var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.district.CWP_ALLOW_PAYMENTS_FLG &&
    _vm.district.CWP_ALLOW_PAYMENTS_FLG === "Y" &&
    _vm.paymentsAreAllowed
    ? _c(
        "div",
        { staticClass: "sapphire-payment-portal" },
        [
          !!_vm.selectedStudent
            ? _c(
                "modal",
                {
                  attrs: {
                    "modal-title": _vm.$t(
                      "MAIN_CONTENT.Fees.RevTrakWebstoreModalTitle"
                    ),
                    show: _vm.getShowWebstoreModal,
                    "dialog-size": "lg",
                    name: "webstore-modal"
                  },
                  on: {
                    close: function($event) {
                      return _vm.closeWebstoreModal()
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(modalProps) {
                          return [
                            _vm.roleRules.FEES_DESCRIPTION_FLG === "Y" &&
                            _vm.headerText.length > 0
                              ? _c("div", {
                                  staticClass: "instructions alert alert-vanco",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.headerText)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row sapphire-payment-portal" },
                              [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "panel webstore-panel" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "panel-body",
                                          staticStyle: { "font-size": "16px" },
                                          attrs: { id: "panel-body-panel-fees" }
                                        },
                                        [
                                          _c(
                                            "h2",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                "Balance " +
                                                  _vm._s(
                                                    _vm._f("dollar")(
                                                      parseFloat(
                                                        _vm.balance.BALANCE
                                                      ).toFixed(2)
                                                    )
                                                  )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-center" },
                                            [
                                              _c("i", [
                                                _vm.balance.MODIFIED_DATE !== ""
                                                  ? _c("small", [
                                                      _vm._v(
                                                        "Last updated as of " +
                                                          _vm._s(
                                                            _vm._f("datetime")(
                                                              _vm.balance
                                                                .MODIFIED_DATE,
                                                              "MMMM, DD YYYY HH:mm:ss",
                                                              "MM/DD/YYYY h:mm a"
                                                            )
                                                          )
                                                      )
                                                    ])
                                                  : _c("small", [
                                                      _vm._v(
                                                        "last update not available"
                                                      )
                                                    ])
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.webstores, function(webstore) {
                                  return _c(
                                    "div",
                                    {
                                      key: webstore,
                                      staticClass: "col-md-6 text-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "panel webstore-panel" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "panel-heading" },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "0px"
                                                  }
                                                },
                                                [
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.buildVancoWebstoreName(
                                                          webstore
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "panel-body",
                                              staticStyle: {
                                                "font-size": "16px"
                                              },
                                              attrs: {
                                                id: "panel-body-panel-fees"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    href: _vm.buildVancoWebstoreUrl(
                                                      webstore
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        "includes/images/RevTrakPay.svg",
                                                      height: "35",
                                                      alt: "RevTrak"
                                                    }
                                                  }),
                                                  _c("aria-new-tab-message", {
                                                    attrs: {
                                                      message: _vm.$t(
                                                        "MAIN_CONTENT.Accessibility.opensInNewTab"
                                                      )
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2472917069
                  )
                },
                [
                  _vm._v(" "),
                  _c("template", { slot: "footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-transparent pull-right",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeWebstoreModal()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$t("MAIN_CONTENT.commonContent.closeButton")
                            ) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }